import React, { useState } from "react";
import { DISTRICTS, LABELLED, LABEL_STYLE, OUTLINE_PATH } from "@/constants/rajasthanMap";

/* Gradients + dot pattern: saffron/gold fills reminiscent of Rajasthani textile borders. */
function MapDefs() {
  return (
    <defs>
      <linearGradient id="rj-fill" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#7c2d12" stopOpacity="0.85" />
        <stop offset="60%" stopColor="#b45309" stopOpacity="0.75" />
        <stop offset="100%" stopColor="#a16207" stopOpacity="0.85" />
      </linearGradient>
      <linearGradient id="rj-stroke" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#fbbf24" />
        <stop offset="100%" stopColor="#f59e0b" />
      </linearGradient>
      <radialGradient id="pin-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#fef3c7" stopOpacity="0.9" />
        <stop offset="60%" stopColor="#fbbf24" stopOpacity="0.4" />
        <stop offset="100%" stopColor="#fbbf24" stopOpacity="0" />
      </radialGradient>
      <pattern id="rj-dots" width="12" height="12" patternUnits="userSpaceOnUse">
        <circle cx="6" cy="6" r="0.6" fill="#fed7aa" fillOpacity="0.35" />
      </pattern>
    </defs>
  );
}

function StateOutline() {
  return (
    <g>
      <path d={OUTLINE_PATH} fill="url(#rj-fill)" />
      <path d={OUTLINE_PATH} fill="url(#rj-dots)" />
      <path d={OUTLINE_PATH} fill="none" stroke="url(#rj-stroke)" strokeWidth="3" strokeLinejoin="round" />
      <path d={OUTLINE_PATH} fill="none" stroke="#fef3c7" strokeWidth="0.6" strokeDasharray="2 4" transform="translate(4,4)" opacity="0.55" />
    </g>
  );
}

function DistrictPin({ x, y, name, index, active, onHover }) {
  const showLabel = LABELLED.has(name) || active;
  return (
    <g onMouseEnter={() => onHover(index)} onMouseLeave={() => onHover(null)} style={{ cursor: "pointer" }}
      data-testid={`district-pin-${name.replace(/\s+/g, "-").toLowerCase()}`}>
      <circle cx={x} cy={y} r={active ? 16 : 10} fill="url(#pin-glow)"
        style={{ transformOrigin: `${x}px ${y}px`, animation: `rj-pulse 2.4s ease-in-out ${(index % 8) * 0.25}s infinite` }} />
      <circle cx={x} cy={y} r={active ? 3.5 : 2.6} fill="#fef3c7" stroke="#f59e0b" strokeWidth="1" />
      {showLabel && <text x={x + 5} y={y - 4} fontSize={active ? 10 : 8.5} fontWeight="700" fill="#fef3c7" style={LABEL_STYLE}>{name}</text>}
    </g>
  );
}

function MapLegend() {
  return (
    <g transform="translate(12, 396)">
      <circle cx="6" cy="6" r="3" fill="#fef3c7" stroke="#f59e0b" strokeWidth="1" />
      <text x="14" y="10" fontSize="10" fontWeight="700" fill="#fef3c7" style={LABEL_STYLE}>33 districts · pan-Rajasthan coverage</text>
    </g>
  );
}

/* Stylized SVG map of Rajasthan with pins for all 33 districts (landing hero). */
export default function RajasthanMap({ className = "" }) {
  const [hoverIdx, setHoverIdx] = useState(null);
  return (
    <div className={`relative ${className}`} data-testid="rajasthan-map">
      <svg viewBox="0 0 460 420" className="w-full h-auto" role="img" aria-label="Rajasthan district coverage map">
        <MapDefs />
        <StateOutline />
        {DISTRICTS.map(([x, y, name], i) => <DistrictPin key={name} x={x} y={y} name={name} index={i} active={hoverIdx === i} onHover={setHoverIdx} />)}
        <MapLegend />
      </svg>
      <style>{`
        @keyframes rj-pulse {
          0%, 100% { opacity: 0.35; transform: scale(0.85); }
          50%      { opacity: 0.9;  transform: scale(1.35); }
        }
      `}</style>
    </div>
  );
}
